import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import  { useState } from "react";
import Text from "../../../components/Text";
import mut from "../../../hooks/mut";

export default function CancelAllLessons(props) {
  const { open, setOpen } = props;
  const [cancelledReason,setCancelledReason] = useState("")
  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Cancel all lessons today</DialogTitle>
      <DialogContent style={{display:"flex",flexDirection:"column", gap:10}}>
        <div>Are you sure? This cannot be undone</div>
        <Text
          value={cancelledReason}
          setValue={setCancelledReason}
          label="Reason"
          nultiline
          rows={3}
                  fullWidth
                  fontSize={12}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
              <Button color="success" disabled={!cancelledReason} onClick={async () => {
                  let res = await mut("post", "/cancel-all-lessons", { cancelledReason })
                  if (res) {
                      setOpen(false)
                  }
        }}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}